/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_Custom_Text_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Add a custom line of text" |
*
* @param {Options_Watermark_Custom_Text_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_custom_text_placeholder = /** @type {((inputs?: Options_Watermark_Custom_Text_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Custom_Text_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter une ligne de texte personnalisée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerdefinierte Textzeile hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi una riga di testo personalizzata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавьте строку произвольного текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir una línea de texto personalizada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加一行自定义文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カスタムテキストの行を追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कस्टम टेक्स्ट की एक पंक्ति जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar uma linha de texto personalizada")
	return /** @type {LocalizedString} */ ("Add a custom line of text")
});